function initBreadcrumbBack () {

	const breadcrumbBackBtns = document.querySelectorAll('.breadcrumbNav__goBack');
	breadcrumbBackBtns.forEach((breadcrumbBackBtn) => {

		breadcrumbBackBtn.addEventListener('click', () => window.history.go(-1));

	});

}

export default initBreadcrumbBack;
